import { authenticationService } from '../../services/auth.service';
import { Navigate } from 'react-router-dom';
import DashboardAuxiliarSec from '../dashboard-auxiliar-sec/DashboardAuxiliarSec';
import DashboardMain from '../dashboard-main/DashboardMain';

export default function Dashboard() {

  const handleDashboard = () => {
    if (authenticationService.isAuxSec()) {
      return <DashboardAuxiliarSec />
    }

    if (authenticationService.isYouth()) {
      return <Navigate to="/umadeub" replace />
    }

    
    if (authenticationService.isAuxCampaign()) {
      return <Navigate to="/campanhas/pessoas" replace />
    }

    return <DashboardMain />
  }

  return <div>{handleDashboard()}</div>
}